<template>
  <div class="pic-content shadow-more">
    <!-- 左边 -->
    <div class="pic-content-left">

      <!-- 左边-内容区 -->
        <div class="pic-content-left-head">
          <button class="example-btn" @click="getExample(0)">样例1</button>
          <button class="example-btn" @click="getExample(1)">样例2</button>
          <button class="example-btn" @click="getExample(2)">样例3</button>
          <button class="example-btn" @click="getExample(3)">样例4</button>
        </div>

      <template v-if="imageUrl&&!manyPicVisible">
        <div class="pic-content-left-pic">
          <div class="swiper-box">
            <template>
              <el-carousel ref="pics" trigger="click" :autoplay="false" :loop="false" height="100"
                           v-on:change="getIndex">

                <el-carousel-item style="display: flex;justify-content: center" v-for="(item,index) in images"
                                  :key="index" name="index">
                  <el-image :preview-src-list="bigImages" @click="choseEventImg(item)" :src="item.url" fit="contain"
                            style="height:100%;weight:100%;object-fit: contain;">
                    <div slot="placeholder"
                         style="margin-top:30%;margin-left:30%;font-weight: bolder;font-size: 10px;color: #606266">
                      加载中<i class="el-icon-loading"></i>
                    </div>
                    <div slot="error" class="image-slot2">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </el-carousel-item>
              </el-carousel>
              <div v-if="this.imageUrl" class="pic-label">{{ this.picLabel }}</div>
            </template>
          </div>
          <!--                    <img :src="imageUrl" style="height:100%;weight:100%;object-fit: contain;" />-->
        </div>

      </template>
      <template v-if="!imageUrl&&!manyPicVisible">
        <div class="pic-content-left-content" @dragover.prevent @drop.prevent="handleDrop" @click="openFileInput">
<div style="height: 100px">
<!--            <svg class="icon" aria-hidden="true">-->
<!--              <use xlink:href="#icon-tupian"></use>-->
<!--            </svg>-->
            <img style="height: 100%;object-fit: contain" src="@/assets/icon/upload.png">
          </div>
          <span style="font-size:16px; color:#909399;margin-bottom: 5px">请点击或拖拽上传图片(大小限制为5MB) </span>
          <span style="font-size:16px; color:#909399">仅支持图片格式为：png，jpg，jpeg，webp</span>
          <input ref="fileInput" type="file" accept="image/*" class="file-input" style="display: none"
                 @change="previewImage"/>
        </div>
      </template>


      <div class="pic-content-left-footer">
        <div class="pic-content-left-footer-button">
          <!-- <el-popover -->
              <!-- placement="top-start" -->
              <!-- offset="170" -->
              <!-- width="520" -->
              <!-- trigger="click" -->
          <!-- > -->
            <!-- <div class="samplelist"> -->
              <!-- <div v-for="(image, index) in Sampleimages" class="sam-pic" :key="index" @click="getImageInfo(image.url)"> -->
                <!-- <el-image style="width: 100px;height: 100px;object-fit: contain" :src="image.url" alt="图片"></el-image> -->
                <!-- <span style="margin-top: 5px;font-size: 15px ;color: #909399">图片描述</span> -->
              <!-- </div> -->
            <!-- </div> -->

            <!-- <button slot="reference" class="footer-btn">样例</button> -->
          <!-- </el-popover> -->

          <!--                    <button style="width: 115px" class="footer-btn" v-if="!manyPicVisible" @click="manyPicVisible=true">上传多张图片</button>-->
          <div class="pic-content-left-footer-button-left">
            <button class="delete-btn" @click="clearText()">
              <img src="@/assets/icon/delete.png" alt="icon" class="delete-icon">
            </button>
          </div>
          <div class="pic-content-left-footer-button-middle">
<!--            <button class="analysis-btn" v-if="manyPicVisible" @click="manyPicVisible=false">上传单张照片</button>-->
          </div>
          <div class="pic-content-left-footer-button-right">
            <button class="analysis-btn" @click="anlaData()">图片分析</button>
          </div>
        </div>
      </div>

    </div>

    <el-dialog
        :append-to-body='true' title="预览" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <!-- 右边 -->
    <!-- 右边 -->
    <div class="pic-content-right"
         v-loading="loading"
         element-loading-background="#f9fbfe"
         element-loading-text="风险内容检测中……"
    >
      <div v-if="this.images.length>1 || this.navshow" class="nav-bar">
        <el-radio-group v-model="detect_mode" @change="handleChange">
          <el-radio-button label="图片伪造结果">
            <template slot="label">
              图片伪造结果
              <i class="el-icon-picture" style="margin-left: 8px;"></i>
            </template>
          </el-radio-button>
          <el-radio-button label="人脸检测结果">
            <span>人脸检测结果 <i v-if="faceLoading" class="el-icon-loading"></i></span>
          </el-radio-button>

        </el-radio-group>
      </div>


    <template v-if="loading===false">
      <template v-if="!isfaces">

        <template v-if="this.images.length > 0">

          <div class="pic-score">
            <!-- 右边-上方 -->
            <div class="pic-content-right-up">

              <div class="pic-content-right-up-text">
                <div class="pic-content-right-text-up">
                  <el-alert
                    v-if="diff_score < 50"
                    description="你输入的内容伪造可能性低"
                    type="success"
                    center
                    :closable="false"
                    show-icon>
                  </el-alert>
                  <el-alert
                    v-if="diff_score >= 50"
                    description="你输入的内容似乎是由AI生成的"
                    type="warning"
                    center
                    :closable="false"
                    show-icon>
                  </el-alert>
                </div>
                <div class="pic-content-right-text-down">
                  <!--                              <countTo :class="{text_transition:this.resultData.power>70}" :startVal='0' :endVal='resultData.power' :suffix='"%"' :duration='600'></countTo>-->
                  <CircleProgress :size="120" :progress="diff_score"></CircleProgress>

                </div>
              </div>
            </div>
            <!-- 右边-下方 -->
            <div class="pic-content-right-down">

              <div class="pic-content-right-down-title">
                <!--                           <template v-if="resultData.messageList && resultData.messageList.length > 0">-->
                <div class="pic-content-right-down-error summary">
                  <span style="border-bottom: 1px solid #91aee8;margin-bottom: 5px;padding-bottom: 16px;">图片内容信息:</span>
                  <span style="font-family: 'PingFang SC';text-align: justify;"
                        class="pic-text"
                  >
                                       <el-skeleton v-if="!imageSummary" :rows="4" animated/>
                                        <span v-html="imageSummary" style="text-indent: 2em;"> </span>
                                    </span>
                </div>
                <!--                            </template>-->
                <!--                            <template v-else>-->
                <!--                                <div class="pic-content-right-down-success">-->
                <!--                                    <span style="color:#00B050">检测内容正常</span>-->
                <!--                                </div>-->
                <!--                            </template>-->
              </div>
            </div>
          </div>
        </template>


      </template>

      <!-- 幻灯片 -->

      <template v-else>
        <div class="face-content" v-loading="faceLoading"
             element-loading-background="#f9fbfe"
             element-loading-text="人脸内容检测中……"
        >
          <div class="pics-content"
               v-show="!noFace&&!faceError"
          >
            <!--                  v-if="!noFace&&!faceError"   或者换成v-show？？？？？？？？？？ -->



            <div class="left-faces">

              <div class="left-face" v-for="(item,index) in faces"
                   :key="index"
                   @click="selectFace(index)"
                   :class="{ active: selectedFace === index }"
              >
                <el-image style="width: 100%;height: 100%; object-fit: contain" :src="item.face">
                  <div slot="placeholder" style="margin-left: 30%;margin-top:30%;font-size: 10px;color: #909399">
                    加载中<i class="el-icon-loading"></i>
                  </div>
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>

              </div>


            </div>


            <div class="form-area">
              <div class="face-mask summary">
                <div style="font-size: 18px;font-weight: bolder;margin-bottom: 5px">伪造区域标注图:</div>
                <el-image style="height: 150px;width:150px;" :src="mask_url" fit="contain">
                  <div slot="placeholder" style="margin-left: 30%;margin-top:30%;font-size: 10px;color: #909399">
                    加载中<i class="el-icon-loading"></i>
                  </div>
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>

                <div style="
                         margin-top: 8px;
                        font-size: 18px;
                        font-weight: bolder;
                        margin-bottom: 10px;"
                >人脸伪造分数:
                  <countTo :class="{text_transition:this.score>50}" style="font-size: 25px" :decimals='1' :startVal='0'
                           :endVal='this.score' :suffix='"%"' :duration='600'></countTo>
                </div>
              </div>

              <div class="pic-content-right-down-error summary" style="margin: 0">
                <span style="border-bottom: 1px solid #91aee8;margin-bottom: 5px;padding-bottom: 16px;">人脸伪造区域信息:</span>
                <el-skeleton v-if="areaDescription.length===0||faceDescription.length===0" animated :rows="4"></el-skeleton>
                <span v-else style="font-family: 'PingFang SC'"
                      class="pic-text"
                      v-html="twoDescription"
                >

                </span>
              </div>

            </div>


          </div>
          <div
              v-if="noFace&&!faceError"
              class="no-face-content">
            <div class="result-face">


              <el-result v-if="!faceLoading" icon="success" title="人脸检测完成" subTitle="未检测到图片中人脸">
                <template slot="icon">
                  <el-image style="width: 130px" :src="faceResult"></el-image>
                </template>

              </el-result>
            </div>

          </div>
          <!--                <feedback-btns v-if="!faceLoading" style="padding: 10px" icontype="iconfont icon-download"></feedback-btns>-->
        </div>


      </template>
    </template>
    <template v-if="loading===null">
        <div class="pic-content-right-init">
            <img src="@/assets/icon/robot.png" alt="icon" class="robot-icon">
            <span class="pic-content-right-init-text">检测结果将显示在这里</span>

<!--          <div class="text-content-right-init-middle">-->
<!--            <span>图片伪造结果</span>-->
<!--          </div>-->
<!--          <div class="text-content-right-init-down">-->
<!--            <span>人脸检测结果</span>-->
<!--          </div>-->
        </div>
    </template>

    </div>
  </div>
</template>

<script>

import countTo from "vue-count-to";
import feedbackBtns from "@/components/feedbackBtns.vue";
import config from "@/utils/request/config"
import CircleProgress from "@/components/CircleProgress.vue";


export default {
  components: {CircleProgress, countTo, feedbackBtns},

  data() {
    return {
      faceError: false,
      diff_mask: null,
      noFace: true,
      faceLoading: false,
      isFace: false,
      diff_score: 0,
      activeIndex: '1',
      // aiScore: 0,
      mask_url: null,
      selectedIndex: null,
      faceResult: require("@/assets/pic/faceResult.png"),
      score: 0,
      loading: null,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      manyPicVisible: false,
      selectedFace: null,
      faces_pic: null,
      bigImages: [],
      faces: [],
      faceDescription: [],
      areaDescription: [],
      Sampleimages: [
        {url: require("@/assets/testPics/hrampic.jpg")},
        {url: require("@/assets/testPics/wholepic.png")},
        {url: require("@/assets/testPics/partpic.jpg")},
        {url: require("@/assets/testPics/faces.png")},

      ],

      currentIndex: 0,
      selectedFile: null,
      imageUrl: '',
      navshow: false,
      imageError: false,
      twoDescription:'',
      images: [],
      detect_mode: "图片伪造结果",
      resultData: {},
      imageSummary: "",
      picLabel: "原始图片",
      labels: ["原始图片"],

      textErrorSrc: require('@/assets/pic/error-robot.svg'),
      textSuccessSrc: require('@/assets/pic/safe_pass.svg'),
      currentSlide: 0,
      showButtons: false,
      // testurl: require('@/assets/pic/test_imgs/test1.jpg'),
      // slides: [
      //   {
      //     imageUrl: require('@/assets/pic/ai-1.png'),
      //     caption: 'Slide 1'
      //   },
      //   {
      //     imageUrl: require('@/assets/pic/ai-2.png'),
      //     caption: 'Slide 2'
      //   }
      // ]
    }
  },

  watch: {},

  methods: {


    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },

    parseScore(score) {

      let num = parseFloat(score) * 100;
      let formattedNum = Math.round(num * 10) / 10; // 乘以10，四舍五入，再除以10
      return formattedNum
    },
    selectFace(index) {
      this.score = 0
      this.selectedFace = index;
      console.log(index)
      this.mask_url = this.faces[index].mask
      this.score = this.parseScore(this.faces[index].score)
      this.twoDescription = this.faceDescription[index] + '<br>' + '<br>' +this.areaDescription[index]
      console.log(this.score)


    },
    getIndex(val, oldVal) {
      console.log(val)
      if (this.images[val].name === "人脸检测结果") {
        this.detect_mode = "人脸检测结果"
      }
      if (this.images[val].name === "图片伪造结果") {
        this.detect_mode = "图片伪造结果"
      }


      this.picLabel = this.labels[val]
    },
    singleFace(id) {
      console.log(id);
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    handleChange(value) {

      if (value === "图片伪造结果" && this.images.length == 3) {
        this.$nextTick(() => {
          // 使用 nextTick 确保 DOM 更新后再执行
          this.$refs.pics.setActiveItem(1);
        });
        return

      }
      if (value === "人脸检测结果" && this.images.length === 3) {
        this.$nextTick(() => {
          // 使用 nextTick 确保 DOM 更新后再执行
          this.$refs.pics.setActiveItem(2);
        });
      }
    },
    handleDrop(event) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        this.selectedFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
          this.images.push({url: this.imageUrl})
        };
        reader.readAsDataURL(file);
      } else {
        this.$message.error("请上传支持的图片格式文件")

      }
    },
    selectImage(index) {
      this.selectedIndex = index;
    },
    async fetchFile(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const file = new File([blob], 'sample.jpg', { type: blob.type });
        this.selectedFile = file;
      } catch (error) {
        console.error('Error fetching file:', error);
      }
    },

    openFileInput() {
      this.$refs.fileInput.click()
    },
    previewImage(event) {
      const file = event.target.files[0];
      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageUrl = e.target.result;
        this.images.push({url: this.imageUrl})

      };
      reader.readAsDataURL(file);

      // 清除文件输入框的值，避免浏览器缓存
      event.target.value = '';
    },
    async anlaData() {
      await this.uploadFile();
    },
    getExample(index) {
      this.clearText()
      this.imageUrl = this.Sampleimages[index].url
      this.fetchFile(this.imageUrl)
      // console.log(this.selectedFile,"mmmm")
      this.images.push({url:this.imageUrl})

      //演示案例


    },
    getMessage(content) {
      //加g是替换字符串里出现的所有\n，不加g是替换字符串里出现的第一个\n
      content = content.replace(/(###\s+([^\s]+))|(\*\*(.*?)\*\*|\n)/g, (match, p1, p2, p3, p4) => {
        if (match === '\n') {
          return '<br/>';
        } else if (p1) {
          // 处理###加粗文本
          return '<strong >' + p2 + '</strong><br/>';
        } else if (p3) {
          // 处理**加粗文本
          return '<strong>' + p4 + '</strong>';
        }

        return match;
      });
      content = content.replace(/(<br\/>\s*){3,}/g, '<br/><br/>');
      return content
    },


    clearText() {
      //演示案例
      this.imageSummary = ''
      this.imageUrl = "";
      this.navshow = false
      this.diff_score = 0
      this.resultData = {};
      this.isfaces = false;
      this.detect_mode = "图片伪造结果"
      this.picLabel="原始图片"
      this.twoDescription = ''
      this.images = []
      this.labels = ["原始图片"]
      this.imageError = false
      this.selectedFace = null
      this.faces = []
      this.faceDescription = []
      this.areaDescription = []
      this.loading = null
    },
    //文件上传

    async uploadFile() {
      if (!this.selectedFile&&!this.imageUrl) {
        this.$message.warning('请先选择所需上传的文件');
        return;
      }
      try {
        // 使用 await 等待异步操作完成
        this.loading = true;
        this.faceLoading = true;
        let timestamp = Date.now();
        const additionalData = {type: 'pic', timestamp: timestamp};
        const resFile = await this.apis.uploadFile(this.selectedFile, additionalData);
        console.log(resFile.data.message);
        if (resFile.data.message === '文件上传成功') {
          this.$message.success('文件上传成功');

          this.picAnalysis(timestamp);
        }
      } catch (error) {
        this.$message.error('文件上传失败');
        console.error('上传失败:', error);
      } finally {
        this.fileLoading = false;

      }
    },

    //文件分析
    picAnalysis(timestamp) {


      this.apis.diffusionDetect({
        type: 'pic',
        fileName: this.selectedFile.name,
        fileTimestamp: timestamp
      })
          .then(res => {
            console.log(res)

            this.diff_mask = this.handlePath(res.mask_path)


            this.images.push({url: this.diff_mask, name: "图片伪造结果"})
            this.labels.push("伪造区域图")
            this.$nextTick(() => {
              // 使用 nextTick 确保 DOM 更新后再执行
              this.$refs.pics.setActiveItem(this.images.length - 1);
            });
            this.loading = false
            this.$message.success("图像伪造检测完成")
            this.$nextTick(() => {
              // 使用 nextTick 确保 DOM 更新后再执行
              this.diff_score = this.parseScore(res.probability)
            });

          })
          .catch(err => {
            this.detect_mode = "人脸检测结果"
            this.imageError = true

            console.log(err)
            this.navshow = true

            // this.loading = false
            this.$notify.error({
              title: '图像伪造检测失败',
              message: err
            });
          }).finally(() => {
        this.loading = false
      })

      this.apis.faceForgeryDetect({
        type: 'pic',
        fileName: this.selectedFile.name,
        fileTimestamp: timestamp
      })
          .then(res => {
            console.log(res)

            if (res.is_face) {

              this.isFace = true
              this.faces_pic = this.handlePath(res.face_detect_result)
              this.images.push({url: this.faces_pic, name: "人脸检测结果"})
              this.labels.push("人脸检测框图")

              let ffaces = res.faces
              let masks = res.masks
              let scores = res.scores
              let filePaths = ffaces.join(', ');
              console.log(filePaths)
              console.log(ffaces)
              this.twoModelResult(filePaths)
              this.faces = ffaces.map((face, index) => {
                return {
                  face: config.baseURL + "/images" + face.slice(face.lastIndexOf('/')),
                  mask: config.baseURL + "/images" + masks[index].slice(masks[index].lastIndexOf('/')),
                  score: scores[index]
                };
              });
              this.$nextTick(() => {
                // 使用 nextTick 确保 DOM 更新后再执行
                this.$refs.pics.setActiveItem(this.images.length - 1);
              });
              this.$nextTick(() => {
                this.selectFace(0);
                this.faceLoading = false
                this.noFace = false
              });
            } else {
              this.noFace = true
              this.faceLoading = false
            }
            this.$message.success("人脸检测完成")


          })
          .catch(err => {
            console.log(err)
            // this.loading = false
            this.$notify.error({
              title: '人脸检测失败',
              message: err
            });
            this.faceLoading = false
            this.faceError = true

          });

      this.apis.modelResult({
        name: "imageRiskDetect",
        fileName: this.selectedFile.name,
        fileTimestamp: timestamp,
        text: "",
      })
          .then(res => {
            this.imageSummary = this.getMessage(res.summary)

          })
          .catch(err => {
            console.log()
            this.$notify.error({
              title: '系统错误，请联系管理员。',
              message: err
            });
          });


    },


    async twoModelResult(paths) {
      paths = paths.replace(/\s+/g, '');
      try {
        const [res1, res2] = await Promise.all([
          this.apis.modelResult({
            name: "imageFaceDescription",
            filePaths:paths

          }),
          this.apis.modelResult({
            name: "imageMaskDescription", // 更改为你的第二个请求的名称
            filePaths:paths
          })
        ]);
        console.log(res1)
        console.log(res2)

        this.faceDescription = res1.description;
        this.areaDescription = res2.description;
        this.$nextTick(()=>{
          this.selectFace(this.selectedFace)
        })

      } catch (err) {
        console.error(err);
        this.$notify.error({
          title: '系统错误，请联系管理员。',
          message: err,
        });
      }
    },
    choseEventImg(item) {

      this.bigImages = [];
      this.bigImages[0] = item.url;
    },
    handlePath(url) {
      return config.baseURL + "/images" + url.slice(url.lastIndexOf('/'))

    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    },
    getMore() {
      this.isfaces = true;
    },
    backHome() {
      this.isfaces = false;
    },

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    next() {
      if (this.currentIndex < this.maxIndex - 1) {
        this.currentIndex++;
      }
    }
  },
  computed: {


    isfaces() {


      return this.detect_mode === "人脸检测结果"
    }


  },
}
</script>

<style>
.carousel-container {
  border: 3px solid #90939973;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  position: relative;
  width: 90%;
  overflow: hidden;
}


.left-faces {
  overflow-y: auto;
  width: 25%;
  max-height: 105%;
  display: flex;
  flex-direction: column;
  align-content: center;
  padding: 0 2px;
  overflow-x: hidden;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.left-face {
  cursor: pointer;
  padding: 2px;

  //height: 120px;
  margin: 5px 0;
  transition: all 0.02s cubic-bezier(0.4, 0, 1, 1);
}

.no-face-content {
  display: flex;
  padding: 10px;
  height: 90%;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.pic-text {
  margin-top: 10px;
  line-height: 1.5;
  font-weight: lighter;
  font-size: 15px;
  color: #606266;
}

.text_transition {
  animation: colorChange 0.6s forwards;
}

.el-divider el-divider--horizontal {
  margin: 0;
}

.sam-pic {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin: 3px;
  transition: outline 0.03s ease;
}

.sam-pic:hover {
  outline: 2px solid #c0c4cc;
  border-radius: 8px;
  cursor: pointer;
}

.left-face.active {
  border-radius: 2px;
  outline: #c0c4cc solid 3px;
  animation: add-border-animation 0.01s ease;
}


@keyframes colorChange {
  from {
    color: black;
  }
  to {
    color: #d91c1cf0;
  }
}

.swiper-box {
  width: 100%;

}

.image-wrapper {
  padding: 3px;
  margin: 8px;
}

.el-progress__text {
  font-size: 33px !important;
}


.image-slot {
  background-color: rgba(208, 206, 206, 0.78);
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-slot2 {
  //background-color: rgba(208, 206, 206, 0.78);
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.score-area {
  display: flex;
  font-weight: bolder;
  font-size: 22px;
  height: 100px;
  flex-direction: column;
  justify-content: center;
}

.image-wrapper.selected {
  outline: 4px solid #409eff;
  border-radius: 10px;
}

.image-wrapper:hover {
  cursor: pointer;
}

.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
  box-shadow: -1px 0 0 0 rgba(64, 158, 255, 0);
}

.carousel-wrapper {
  overflow: hidden;
  width: 100%;
}
.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #FFF;
  background-color: #470790;
  border-color: #470790;
}

.el-radio-button__inner:hover{
  color:#470790 ;
}
.face-mask {
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;

}

.form-area {
  width: 70%;
  height: 80%;
  padding-left: 10px;
}

.carousel {
  display: flex;
  transition: transform 0.3s ease;
}

.carousel-item {
  width: 25%;
  display: flex;
}

.samplelist {
  display: flex;

}

.carousel-button {
  height: 100%;
  width: 15px;
  background-color: #c0c4cc;
  color: white;
  font-weight: bolder;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.left-button {
  left: 0;
}

.right-button {
  right: 0;
}

.pic-content {
  display: flex;
  height: 65vh;
  background-color: #F9FBFE;
  width: 77vw;
  border-radius: 35px;
  padding: 20px;
  padding-top: 15px;
}



.pic-label {
  color: #909399;
  /* top: 42px; */
  display: flex;
  /* align-items: center; */
  justify-content: center;
  margin-top: 10px;
}

.el-loading-spinner .el-loading-text {
  font-size: 20px;
}

.left-faces::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.left-faces::-webkit-scrollbar-track {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}
.left-faces::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}

.pic-score {
  overflow-x: hidden;
  overflow-y: auto;
}

.pic-score::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.pic-score::-webkit-scrollbar-track {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}
.pic-score::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}

.pic-content-left {
  border-right: 1px solid #91aee8;
  padding:0 10px;
  margin-right: 10px;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
}

.pic-content-left-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 8%;
  margin-top: 10px;
;
}

.pic-content-left-pic {
  border: 1px #c0c4cc solid;
  border-radius: 15px;
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.many-upload {
  height: 90%;
}

.pic-content-left-content {
  height: 80%;
  width: 100%;
  border: 1px #c0c4cc dashed;
  //background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;

}

.file-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: auto;
  /* 调整为自动宽度 */
  height: 100%;
  /* 调整高度以匹配按钮 */
  opacity: 0;
  cursor: pointer;
}

.single-face {
  height: 90%;
  width: 20%;
  margin: 5px;
  object-fit: contain;
}

.not-fakefaces {
  width: 100%;
  height: 20%;
  border: 1px solid black;
  border-radius: 20px;

}

.fakefaces {
  width: 100%;
  height: 20%;
  border: 3px solid #f60c0c;
  border-radius: 20px;
}

.pic-content-left-footer {
  display: flex;
  align-items: center;
  height: 10%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
}

.pic-content-left-footer-button {
  height: 100%;
  width:100%;
  display: flex;
  flex-direction: row;
}

.pic-content-left-footer-button-left{
  height: 100%;
  border-radius: 100px;
  flex:1;
  display:flex;
  align-items: center;
  transition: background-color linear 0.15s ;
}

.pic-content-left-footer-button-middle{
  height: 100%;
  flex:4;
  display:flex;
  align-items: center;
}

.pic-content-left-footer-button-right{
  height: 100%;
  flex:4;
  display:flex;
  align-items: center;
}

.delete-btn {
  border: none;
  background-color: transparent;
  padding: 0;
  width: auto;
  height: auto;
  //margin-right: 8px;
}

.delete-btn .delete-icon {
  width: 24px;
  height: 24px;
}

.text-delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin-right: 8px;
  padding: 4px;

  border-radius: 100px;
  transition: background-color 0.15s ease;
}
.text-delete-btn:hover {
  background-color: #ebeef5;
}

.analysis-btn {
  margin-left: 80px;
  width:70%;
  border-radius: 9px;
  font-weight: bold;
  height: 100%;
  border: none;
  background-color: #470790;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  transition: ease background-color 0.15s;
}

.analysis-btn:hover {
  background-color: #470790cc;
  box-shadow: 0 0 3px #6633a1;
}

.nav-bar {
  display: flex;
  justify-content: center;
  height: 8%;
}

.pic-content-right-init{
  display: flex;
  flex-direction: column;
  height:80%;
  justify-content: center;
  align-items: center;
}

.pic-content-right-init-text{
  font-weight: bold;
  color:#c3c7d6;
}

.pic-content-right {
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
  opacity: 0;
}
.pic-content-left-footer-button-left:hover {
  background-color: #e4e7eda3;
}


.pic-content-right-up {
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px 0 ;

}

.pic-content-right-up-pic {
  flex: 2;
  display: flex;
  justify-content: center;

}

.pic-content-right-up-text {
  flex: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pic-content-right-text-up {
  font-size: 25px;
  font-weight: bolder;
}

.pic-content-right-text-down {
  margin-top: 15px;


}

.pic-content-right-down {
  flex: 3;
  //padding: 0 20px;
}

.pic-content-right-down-title {
  flex: 4;
}

.pic-content-right-down-success {
  font-size: 35px;
  font-weight: 500;
  margin: 50px 0 0 20px;
}

.pic-content-right-down-error {
  font-size: 17px;
  font-weight: bolder;

  margin: 0 5px 0 10px;
  display: flex;
  flex-direction: column;

  color: #303133;
  font-family: 'PingFang SC'
}

.pic-content-right-down-page {
  height: 10%;
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
}

.face-content {
  height: 90%;
  width: 100%;
}

.pics-content::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.pics-content::-webkit-scrollbar-track {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}
.pics-content::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}


.face-content::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.face-content::-webkit-scrollbar-track {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}
.face-content::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}

.pics-content {
  padding: 10px;
  height: 90%;
  width: 100%;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
}

.slideshow {
  position: relative;
  height: 50%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slideshow-pic {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slide-pic {
  position: relative;
  -o-object-fit: contain;
  object-fit: contain;
  height: 80%;
  width: 80%;
}

.prev-button,
.next-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

.prev-button {
  left: 10px;
}

.next-button {
  right: 10px;
}

.prev-button:hover,
.next-button:hover {
  display: block;
  /* 鼠标悬停时显示按钮 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}


</style>
